import { render, staticRenderFns } from "./WapprAttach.vue?vue&type=template&id=015049a4&"
import script from "./WapprAttach.vue?vue&type=script&lang=js&"
export * from "./WapprAttach.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports